var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8136 5.2377C16.4213 4.84531 15.9557 4.53404 15.4431 4.32168C14.9306 4.10931 14.3813 4 13.8265 4C13.2717 4 12.7223 4.10931 12.2098 4.32168C11.6973 4.53404 11.2316 4.84531 10.8394 5.2377L10.0254 6.05166L9.21146 5.2377C8.41924 4.44548 7.34475 4.00041 6.22438 4.00041C5.104 4.00041 4.02951 4.44548 3.23729 5.2377C2.44507 6.02993 2 7.10441 2 8.22479C2 9.34516 2.44507 10.4196 3.23729 11.2119L4.05125 12.0258L10.0254 18L15.9996 12.0258L16.8136 11.2119C17.2059 10.8197 17.5172 10.354 17.7296 9.84146C17.9419 9.32893 18.0513 8.77958 18.0513 8.22479C18.0513 7.67 17.9419 7.12064 17.7296 6.60811C17.5172 6.09558 17.2059 5.62991 16.8136 5.2377V5.2377Z",
    stroke: "#ff4848",
    strokeWidth: 1.9,
    fill: "#ff4848",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiked);
export default __webpack_public_path__ + "static/media/liked.9ca9e868d3897eab1d07c062e4faddf9.svg";
export { ForwardRef as ReactComponent };